import { useEffect, useState } from "react";
import { useFieldArray } from "react-hook-form";
import styes from '../../../../styles/transitionplan.module.css';
import { Button, Col, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import IncidentFollowupResponsesForm from "./incidentfollowupresponsesform";

const IncidentFollowupResponses = ({control,definitions}) => {
    const {fields,append,remove,update} = useFieldArray({
        control,
        name: 'responses',
        keyName: 'rhfid' //RHF needs an id to automatically track. By default this is id but since we already use id we must change
    });

    const [editIndex,setEditIndex] = useState(() => fields.length > 0 ? fields.length - 1 : null);
    const [formKey,setFormKey] = useState(crypto.randomUUID());

    const _newItem = () => {
        setEditIndex(null);
    }
    
    const findUserText = (id) => {
        return definitions.usermasterlist.find(item => item.id === parseInt(id))?.name;
    }
    
    useEffect(() => {
        setFormKey(crypto.randomUUID());
    },[editIndex])
    return(
        <div style={{backgroundColor: 'rgb(219,219,219)',border: '1px dashed black', padding: '4px'}}>
            <Row>
                <Col xs={12}>
                    <div className="d-flex justify-content-between">
                        <div style={{display: "flex", gap: '8px',flexWrap: 'wrap',alignItems: 'center'}} className="containBox">
                            {
                                fields.map((item,index) => (
                                    <button key={item.id} type="button" className={`containItem ${editIndex === index ? 'active' : null}`} onClick={() => setEditIndex(index)}>{findUserText(item.whoCompletedTheAnalysis)}</button>
                                ))
                            }
                            {
                                editIndex !== null
                                &&
                                    <Button type="button" variant="success" size="sm" className='addContainItem' title="New Response" aria-label="New Response" onClick={_newItem} >
                                        <FontAwesomeIcon icon={faPlus} />
                                    </Button>
                            }
                        </div>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col xs={12}>
                    <IncidentFollowupResponsesForm key={formKey} item={editIndex !== null ? fields[editIndex] : null} definitions={definitions} submitFn={(data) => {
                        const entryWithId = {
                            ...data,
                            id: data.id !== null ? data.id : crypto.randomUUID(), // preserve existing id if editing
                        };
                        if (editIndex !== null) {
                            update(editIndex, entryWithId);
                            setFormKey(crypto.randomUUID()); //Forces remount so sub component can capture changed values and update dirty state
                        } else {
                            append(entryWithId);
                            setEditIndex(fields.length);
                        }
                    }}/>
                </Col>
            </Row>
        </div>
    )
}

export default IncidentFollowupResponses;